import React from 'react';
import styles from './SubmitLoader.module.css';

interface SubmitLoaderProps {
  isVisible: boolean;
  message?: string;
  type?: 'submit' | 'save' | 'update' | 'create' | 'delete';
}

const SubmitLoader: React.FC<SubmitLoaderProps> = ({
  isVisible,
  message,
  type = 'submit'
}) => {
  if (!isVisible) return null;

  // Default messages based on type
  const defaultMessages = {
    submit: 'Submitting...',
    save: 'Saving...',
    update: 'Updating...',
    create: 'Creating...',
    delete: 'Deleting...'
  };

  const displayMessage = message || defaultMessages[type];

  return (
    <div className={styles.overlay}>
      <div className={styles.loaderContainer}>
        {/* Animated Check Icon */}
        <div className={styles.iconWrapper}>
          <svg className={styles.checkIcon} viewBox="0 0 52 52">
            <circle className={styles.checkCircle} cx="26" cy="26" r="25" fill="none"/>
            <path className={styles.checkPath} fill="none" d="M14.1 27.2l7.1 7.2 16.7-16.8"/>
          </svg>
        </div>

        {/* Loading Spinner */}
        <div className={styles.spinner}>
          <div className={styles.spinnerCircle}></div>
        </div>

        {/* Message */}
        <p className={styles.message}>{displayMessage}</p>

        {/* Animated Dots */}
        <div className={styles.dots}>
          <span className={styles.dot}></span>
          <span className={styles.dot}></span>
          <span className={styles.dot}></span>
        </div>
      </div>
    </div>
  );
};

export default SubmitLoader;